import { useDispatch } from "react-redux";
import type { AppDispatch } from "../app/store";

// Typed dispatch hook for Redux Toolkit
export const useAppDispatch: () => AppDispatch = useDispatch;
